module.exports = __webpack_public_path__ + "static/img/2.17fab08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/2.png
// module id = 04Xv
// module chunks = 0